import image1 from '@/assets/carousel-images/818002207_4.jpg';
import image2 from '@/assets/carousel-images/750000492_4.jpg';
import image3 from '@/assets/carousel-images/837000003_6.jpg';
import image4 from '@/assets/carousel-images/740000018_4.jpg';
import image5 from '@/assets/carousel-images/939001655_1.jpg';
import image6 from '@/assets/carousel-images/750000045_5.jpg';
import image7 from '@/assets/carousel-images/754000266_4.jpg';
import image8 from '@/assets/carousel-images/837001769_4.jpg';
import image9 from '@/assets/carousel-images/834000340_4.jpg';
import image10 from '@/assets/carousel-images/837000214_13.png';
import image11 from '@/assets/carousel-images/747000510_4.jpg';
import image12 from '@/assets/carousel-images/938000100_4.jpg';
import image13 from '@/assets/carousel-images/836000079_4.jpg';
import image14 from '@/assets/carousel-images/938000323_4.jpg';
import image15 from '@/assets/carousel-images/939000374_10.jpg';
import image16 from '@/assets/carousel-images/747001093_5.jpg';
import image17 from '@/assets/carousel-images/938001025_4.jpg';
import image18 from '@/assets/carousel-images/939001690_2.jpg';
import image19 from '@/assets/carousel-images/837001342_4.jpeg';
import image20 from '@/assets/carousel-images/834000336_4.jpg';
import image21 from '@/assets/carousel-images/836000951_4.jpg';
import image22 from '@/assets/carousel-images/837000031_4.jpg';
import image23 from '@/assets/carousel-images/837003190_10.jpg';
import image24 from '@/assets/carousel-images/837001107_4.jpg';
import image25 from '@/assets/carousel-images/939001641_4.jpg';

export const carouselImages = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
  image21,
  image22,
  image23,
  image24,
  image25
];
